export default __webpack_public_path__ + "static/media/flying-donkey.980d2850.png";